// extracted by mini-css-extract-plugin
export default {"imageWrapper":"CK-z","twoColumnImage":"DK-z"};